var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconThreeDot(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 4,
    viewBox: "0 0 12 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.79998 0.700012C1.19998 0.700012 0.599976 1.20001 0.599976 1.90001C0.599976 2.50001 1.09998 3.10001 1.79998 3.10001C2.39998 3.10001 2.99998 2.60001 2.99998 1.90001C2.89998 1.20001 2.39998 0.700012 1.79998 0.700012ZM6.09998 0.700012C5.49998 0.700012 4.89998 1.20001 4.89998 1.90001C4.89998 2.50001 5.39998 3.10001 6.09998 3.10001C6.69998 3.10001 7.29998 2.60001 7.29998 1.90001C7.19998 1.20001 6.69998 0.700012 6.09998 0.700012ZM10.4 0.700012C9.79998 0.700012 9.19998 1.20001 9.19998 1.90001C9.19998 2.50001 9.69998 3.10001 10.4 3.10001C11.1 3.10001 11.6 2.60001 11.6 1.90001C11.5 1.20001 11 0.700012 10.4 0.700012Z",
    fill: "#282934"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThreeDot);
export default __webpack_public_path__ + "static/media/icon-three-dot.5252e66b623affdaa42f27079ea6f58b.svg";
export { ForwardRef as ReactComponent };